// extracted by mini-css-extract-plugin
module.exports = {"container":"i_HU","dark":"i_HV","light":"i_HW","bubble":"i_HX","header":"i_HY","logo":"i_HZ","now":"i_Ha","body":"i_Hb","title":"i_Hc","image":"i_Hd","message":"i_He"};